module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "800px"
    },
    on: {
      "input": _vm.close
    }
  }, [_c('v-card', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v(_vm._s(_vm.viewSample.title || 'Stats example'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.sampleImages.length) ? _c('div', [(_vm.sampleImages.length > 1) ? _c('v-carousel', {
    staticClass: "grey lighten-2 payout-sample-carousel",
    attrs: {
      "show-arrows": "",
      "height": "580"
    },
    model: {
      value: (_vm.currentSlide),
      callback: function($$v) {
        _vm.currentSlide = $$v
      },
      expression: "currentSlide"
    }
  }, _vm._l((_vm.sampleImages), function(image) {
    return _c('v-carousel-item', {
      key: image.url
    }, [_c('v-img', {
      staticClass: "white",
      attrs: {
        "src": _vm.imgBaseURL + image.url,
        "lazy-src": _vm.imgBaseURL + image.url,
        "alt": image.title,
        "contain": "",
        "height": "530"
      }
    })], 1)
  }), 1) : _c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.imgBaseURL + _vm.sampleImages[0].url,
      "lazy-src": _vm.imgBaseURL + _vm.sampleImages[0].url,
      "alt": _vm.sampleImages[0].title,
      "contain": "",
      "max-height": "560"
    }
  }), _vm._v(" "), (_vm.sampleImages.length > 1) ? _c('div', {
    staticClass: "text-center caption font-weight-medium mt-2",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v("\n            Slide " + _vm._s(_vm.currentSlide + 1) + " of " + _vm._s(_vm.sampleImages.length) + "\n          ")]) : _vm._e()], 1) : (_vm.viewSample.metrics) ? _c('v-card', {
    staticClass: "pa-5",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-3"
  }, [_vm._v("Stats to submit")]), _vm._v(" "), _vm._l((_vm.viewSample.metrics), function(metric) {
    return _c('v-chip', {
      key: metric,
      staticClass: "ma-1",
      attrs: {
        "color": "secondary",
        "outlined": ""
      }
    }, [_vm._v(_vm._s(metric))])
  })], 2) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-735329ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/PayoutSampleModal.vue
// module id = 2194
// module chunks = 0